import { OverlayView } from "@react-google-maps/api";
import React from "react";

const MainGPSandDetails = ({
  gpsData,
  currentCoordinate,
  handleMarkerClick,
}) => {
  return (
    <OverlayView
      position={currentCoordinate}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      getPixelPositionOffset={(width, height) => ({
        x: -(width / 2),
        y: -(height / 2),
      })}
    >
      <button
        type="button"
        onClick={() => handleMarkerClick(gpsData?.gpsValues)}
        className="block w-12 h-12 border-0 bg-transparent p-0 cursor-pointer"
        title="Current vehicle location"
      >
        <img
          src={`${process.env.PUBLIC_URL}/bike-icon-bms.png`}
          alt="Vehicle location"
          className="block w-12 h-12 object-contain drop-shadow-lg"
        />
      </button>
    </OverlayView>
  );
};

export default MainGPSandDetails;
